export default "__VITE_ASSET__Del0KrsW__"